<template>
  <!-- 投资项目管理 -->
  <div class="rightbox backwhite width86 border-rd3 pad-bot30 alldigitals">
    <el-skeleton
      class="width90 margin-auto margin-top30"
      :loading="true"
      animated
      :throttle="500"
    >
      <template slot="template">
        <!-- 头部 -->
        <div class="informationenterprise f14 lineheight40 pad-left10">
          企业基本信息
        </div>
        <!-- 上面输入框 -->
        <div class="flex-betweenwrap pad-left10 pad-right10">
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">企业名称</p>
            <el-input
              v-model="Enterprisename"
              placeholder="请输入企业名称"
            ></el-input>
          </div>
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">曾用名</p>
            <el-input
              v-model="Formername"
              placeholder="请输入曾用名"
            ></el-input>
          </div>
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">年报地址</p>
            <el-input
              v-model="reportaddress"
              placeholder="请输入最新年报地址"
            ></el-input>
          </div>
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">年报行业</p>
            <el-input
              v-model="reportindustry"
              placeholder="请输入最新年报行业"
            ></el-input>
          </div>
        </div>
        <!-- 中间 -->
        <div class="flex-betweenwrap pad-left10 pad-right10">
          <!-- 所属园区 -->
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">所属园区</p>
            <el-select
              v-model="zoneid"
              placeholder="请选择所属园区"
              class="width100"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in zonecont"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 注册地址 -->
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">注册地址</p>
            <p>
              <el-select
                v-model="provincename"
                placeholder="请选择省"
                class="width33"
                @change="provincechange"
                :filterable="true"
              >
                <el-option label="---  请选择  ---" value=""></el-option>
                <el-option
                  v-for="item in province"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option> </el-select
              ><el-select
                v-model="cityname"
                placeholder="请选择市"
                class="width33"
                @change="citychange"
                :filterable="true"
              >
                <el-option label="---  请选择  ---" value=""></el-option>
                <el-option
                  v-for="item in city"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option> </el-select
              ><el-select
                v-model="districtname"
                placeholder="请选择区"
                class="width34"
                @change="districtchange"
                :filterable="true"
              >
                <el-option label="---  请选择  ---" value=""></el-option>
                <el-option
                  v-for="item in district"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </p>
          </div>
          <!-- 详细地址 -->
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">详细地址</p>
            <el-input v-model="address" placeholder="请输入详细地址"></el-input>
          </div>
          <!-- 经营场地类型 -->
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">经营场地类型</p>
            <el-select
              v-model="officetype"
              placeholder="请选择经营场地类型"
              class="width100"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in officetypecont"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 经营场地面积(平方米) -->
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">经营场地面积(平方米)</p>
            <el-input
              v-model="square"
              placeholder="请输入经营场地面积(平方米)"
            ></el-input>
          </div>
          <!-- 企业规模 -->
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">企业规模</p>
            <el-select
              v-model="scale"
              placeholder="请选择企业规模"
              class="width100"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in scalecont"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 是否失信 -->
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">是否失信</p>
            <el-select
              v-model="dishonest"
              placeholder="是否失信"
              class="width100"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in dishonestcont"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 社会信用代码) -->
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">社会信用代码</p>
            <el-input
              v-model="certid"
              placeholder="请输入社会信用代码"
            ></el-input>
          </div>
        </div>
        <div class="flex-betweenwrap pad-left10 pad-right10">
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">法人代表</p>
            <el-input
              v-model="legalrepresentative"
              placeholder="请输入法人代表"
            ></el-input>
          </div>
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">总投资(万元)</p>
            <el-input
              v-model="investment"
              placeholder="请输入总投资"
            ></el-input>
          </div>
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">注册资本(万元)</p>
            <el-input v-model="capital" placeholder="请输入注册资本"></el-input>
          </div>
          <div class="width48 f14 margin-top20">
            <p class="pad-bot5">注册时间</p>
            <el-date-picker
              style="width: 100%"
              v-model="registerdate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择注册时间"
            >
            </el-date-picker>
          </div>
        </div>
        <!-- 经营范围 -->
        <div class="margin-top20 width98 margin-auto">
          <p class="pad-bot5">经营范围</p>
          <div class="f12">
            <el-input
              type="textarea"
              :autosize="autosize"
              :rows="7"
              placeholder="请输入内容"
              v-model="scope"
            >
            </el-input>
          </div>
        </div>

        <!-- 所属行业 -->
        <div
          class="width100 pad-top20 pad-bot40 f14"
          style="border-bottom: 1px dashed #ccc"
        >
          <div class="f14 pad-left10">所属行业</div>
          <div class="width98 margin-auto flex-betweennocenters">
            <div class="width48" v-for="(item, index) in page" :key="index">
              <div class="flex-betweenwrap chakall f14">
                <div class="pad-left10 flexleft">
                  <div
                    class="chakbok"
                    :class="industrys.includes(item.id) ? 'chakbokbg' : ''"
                    @click="chakbokjz(index)"
                  >
                    <div style="margin: -3px 0 0 -2px; width: 5px; height: 5px">
                      <svg
                        :class="industrys.includes(item.id) ? 'chakbokfff' : ''"
                        v-if="industrys.includes(item.id) ? true : false"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 32 32"
                      >
                        <path
                          d="M3.821 16.769c-0.311-0.31-0.361-0.793-0.087-1.138l0.64-0.807c0.262-0.331 0.753-0.414 1.1-0.182l5.542 3.699c0.292 0.195 0.795 0.17 1.068-0.052l14.643-11.88c0.329-0.267 0.845-0.244 1.133 0.044l0.361 0.36c0.314 0.313 0.291 0.811-0.038 1.14l-15.716 15.693c-0.489 0.488-1.292 0.467-1.795-0.036l-6.851-6.841z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div>{{ item.name }}</div>
                </div>

                <div
                  v-if="chakboks != index"
                  @click="chakbokzk(index)"
                  class="pad-right10 f14"
                  style="color: #52c5cb"
                >
                  展开
                </div>
                <div
                  v-if="chakboks == index"
                  @click="chakboksq()"
                  class="pad-right10 f14"
                  style="color: #ffcb82"
                >
                  收起
                </div>
              </div>
              <div
                v-if="chakboks == index"
                class="flex-betweenwrap pad-top5 pad-bot5"
                style="background: #f6f7fb"
              >
                <span
                  class="width48 pad-left5 lineheight30"
                  v-for="(_item, _index) in item.data"
                  :key="_index"
                  ><span style="color: #dfdfdf; margin-right: 5px">L</span>
                  <span style="color: #6a7589">{{ _item }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 企业人才信息 -->
        <!-- 头部 -->
        <div class="pad-top20 pad-bot40" style="border-bottom: 1px dashed #ccc">
          <div class="informationenterprise f14 lineheight40 pad-left10">
            企业人才信息
          </div>
          <!-- 下面输入框 -->
          <div class="flex-betweenwrap pad-left10 pad-right10">
            <div class="width48 f14 margin-top20">
              <p class="pad-bot5">员工总数(人)</p>
              <el-input
                v-model="employees"
                placeholder="请输入员工总数"
              ></el-input>
            </div>
            <div class="width48 f14 margin-top20">
              <p class="pad-bot5">参保人数(人)</p>
              <el-input
                v-model="insured"
                placeholder="请输入参保人数"
              ></el-input>
            </div>
            <div class="width48 f14 margin-top20">
              <p class="pad-bot5">专职知识产权人数(人)</p>
              <el-input
                v-model="ipadministrator"
                placeholder="请输入专职知识产权人数"
              ></el-input>
            </div>
            <div class="width48 f14 margin-top20">
              <p class="pad-bot5">大专学历人数（人）</p>
              <el-input
                v-model="college"
                placeholder="请输入大专学历人数"
              ></el-input>
            </div>
            <div class="width48 f14 margin-top20">
              <p class="pad-bot5">本科学历人数（人）</p>
              <el-input
                v-model="bachelor"
                placeholder="请输入本科学历人数"
              ></el-input>
            </div>
            <div class="width48 f14 margin-top20">
              <p class="pad-bot5">研究生及以上学历人才数（人）</p>
              <el-input
                v-model="postgraduate"
                placeholder="请输入研究生及以上学历人才数"
              ></el-input>
            </div>
            <div class="width48 f14 margin-top20">
              <p class="pad-bot5">副高级以上职称数量(人)</p>
              <el-input
                v-model="advancedjob"
                placeholder="请输入副高级以上职称数量"
              ></el-input>
            </div>
            <div class="width48 f14 margin-top20">
              <p class="pad-bot5">国家级人才数量(人)</p>
              <el-input
                v-model="national"
                placeholder="请输入国家级人才数量"
              ></el-input>
            </div>
          </div>
        </div>

        <!-- 下面按钮 -->
        <p class="margin-top20 textalign-right">
          <el-button type="primary" @click="Savedata()">保存资料</el-button>
        </p>
      </template>
    </el-skeleton>

    <!-- 错误弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  companyindustry,
  companyget,
  companyzone,
  companyregion,
  companyrefresh,
} from "@/api/business/business.api";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      Enterprisename: "",
      Formername: "",
      reportaddress: "",
      reportindustry: "",
      zonecont: [],
      zoneid: "",
      province: [],
      provincename: "",
      provinceid: "",
      provincechangeid: "",
      city: [],
      cityname: "",
      cityid: "",
      citychangeid: "",
      district: [],
      districtname: "",
      districtid: "",
      districtchangeid: "",
      address: "",
      officetype: "",
      officetypecont: [
        {
          value: 1,
          label: "写字楼",
        },
        {
          value: 2,
          label: "工厂",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      square: "",
      scale: "",
      scalecont: [
        {
          value: 1,
          label: "微型",
        },
        {
          value: 2,
          label: "小型",
        },
        {
          value: 3,
          label: "中型",
        },
        {
          value: 4,
          label: "大型",
        },
      ],
      dishonest: "",
      dishonestcont: [
        {
          value: 0,
          label: "否",
        },
        {
          value: 1,
          label: "是",
        },
      ],
      certid: "",
      legalrepresentative: "",
      investment: "",
      capital: "",
      registerdate: "",
      industry: [],
      industrys: [],
      page: [],
      activeNames: [],
      employees: "",
      insured: "",
      ipadministrator: "",
      college: "",
      bachelor: "",
      postgraduate: "",
      advancedjob: "",
      national: "",
      scope: "",
      chakboks: 100,
    };
  },
  components: {},
  inject: ["reload"],
  methods: {
    // 展开
    chakbokzk(index) {
      this.chakboks = index;
    },
    // 收起
    chakboksq() {
      this.chakboks = 100;
    },
    // 增减
    chakbokjz(index) {
      if (this.industrys.includes(this.page[index].id)) {
        this.industrys.splice(this.industrys.indexOf(this.page[index].id), 1);
      } else {
        this.industrys.push(this.page[index].id);
      }
    },
    handleChange(val) {},
    // 获取市
    provincechange(value) {
      this.provincechangeid = value;
      if (value != this.provinceid) {
        //获取地址市
        companyregion({ parent_id: value }).then((res) => {
          if (res.data.code == 200) {
            this.city = res.data.data;
            this.cityname = "";
            this.districtname = "";
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        //获取地址市
        this.provincechangeid = this.provinceid;
        companyregion({ parent_id: this.provinceid }).then((res) => {
          if (res.data.code == 200) {
            this.city = res.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    //获取区
    citychange(value) {
      if (value != this.cityid) {
        this.citychangeid = value;
        companyregion({ parent_id: value }).then((res) => {
          if (res.data.code == 200) {
            this.district = res.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        this.citychangeid = this.cityid;
        companyregion({ parent_id: this.cityid }).then((res) => {
          if (res.data.code == 200) {
            this.district = res.data.data;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    districtchange(value) {
      this.districtchangeid = value;
    },
    // 保存资料
    Savedata() {
      companyrefresh({
        zone_id: this.zoneid,
        industry: this.industrys,
        company: this.company,
        dishonest: this.dishonest,
        email: null,
        before_company: this.Formername,
        cert_id: this.certid,
        province_id:
          this.provincechangeid == "" ? this.provinceid : this.provincechangeid,
        city_id: this.citychangeid == "" ? this.cityid : this.citychangeid,
        district_id:
          this.districtchangeid == "" ? this.districtid : this.districtchangeid,
        legal_representative: this.legalrepresentative,
        register_date: this.registerdate,
        website: null,
        employees: this.employees,
        insured: this.insured,
        college: this.college,
        bachelor: this.bachelor,
        postgraduate: this.postgraduate,
        advanced_job: this.advancedjob,
        national: this.national,
        investment: this.investment,
        scale: this.scale,
        scope: this.scope,
        capital: this.capital,
        office_type: this.officetype,
        square: this.square,
        address: this.address,
        madrid: 0,
        pct_patent: 0,
        ip_administrator: this.ipadministrator,
        report_address: this.reportaddress,
        report_tel: null,
        report_industry: this.reportindustry,
      }).then((res) => {
        if (res.data.code == 200) {
          this.reload();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    // 获取行业分类
    companyindustry({ cate_id: 52 }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    //获取企业资料
    companyget({ id: window.sessionStorage.getItem("default") }).then((res) => {
      if (res.data.code == 200) {
        this.Enterprisename = res.data.data.company;
        this.Formername = res.data.data.before_company;
        this.reportaddress = res.data.data.report_address;
        this.reportindustry = res.data.data.report_industry;
        this.zoneid = res.data.data.zone_id;
        if (res.data.data.province != null) {
          this.provincename = res.data.data.province.name;
        } else {
          this.provincename = "";
        }
        this.provinceid = res.data.data.province_id;
        if (res.data.data.city != null) {
          this.cityname = res.data.data.city.name;
        } else {
          this.cityname = "";
        }
        this.cityid = res.data.data.city_id;
        if (res.data.data.district != null) {
          this.districtname = res.data.data.district.name;
        } else {
          this.districtname = "";
        }
        this.districtid = res.data.data.district_id;
        this.address = res.data.data.address;
        this.officetype = res.data.data.office_type;
        this.square = res.data.data.square;
        this.scale = res.data.data.scale;
        this.dishonest = res.data.data.dishonest;
        this.certid = res.data.data.cert_id;
        this.legalrepresentative = res.data.data.legal_representative;
        this.investment = res.data.data.investment;
        this.capital = res.data.data.capital;
        this.registerdate = res.data.data.register_date;
        this.industry = res.data.data.industry;
        this.industry.forEach((i) => {
          this.industrys.push(parseInt(i));
        });
        this.employees = res.data.data.employees;
        this.insured = res.data.data.insured;
        this.ipadministrator = res.data.data.ip_administrator;
        this.college = res.data.data.college;
        this.bachelor = res.data.data.bachelor;
        this.postgraduate = res.data.data.postgraduate;
        this.advancedjob = res.data.data.advanced_job;
        this.national = res.data.data.national;
        this.scope = res.data.data.scope;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    // 获取园区列表
    companyzone().then((res) => {
      if (res.data.code == 200) {
        this.zonecont = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });

    //获取地址省
    companyregion({}).then((res) => {
      if (res.data.code == 200) {
        this.province = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.alldigitals {
  height: 85vh;
  overflow-y: scroll;
}
.informationenterprise {
  margin: 20px 0 10px 0;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #353a44;
  line-height: 16px;
  border-left: 4px solid #52c5cb;
}
.chakall {
  margin: 10px 0 0 0;
  height: 40px;
  background: #f6f7fb;
  border-radius: 3px;
}
.chakbok {
  width: 12px;
  height: 12px;
  border: 1px solid #52c5cb;
  border-radius: 3px;
  margin: 0 10px 0 0;
}
.chakbokbg {
  background: #52c5cb;
}
.chakbokfff {
  fill: white;
}
.industry >>> .el-collapse-item__header {
  height: 28px;
  line-height: 28px;
  border: none;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 10%;
}
</style>